import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import MemberPortalApp from './MemberPortalApp'
import { getStoredMemberClubCode, isCapacitorRuntime } from './lib/mobileBootstrap'
import { notifyMembersMobileBundleReady } from './capgoStartup'
import { logMembersMobileBundleVersions } from './capgoStartup'
import { sendMembersTransportDiagnostic } from './lib/transportDiagnostic'
import { PrivanaI18nProvider } from '@/i18n/PrivanaI18nProvider.jsx'

if (isCapacitorRuntime() && window.location.pathname === '/') {
  const savedClub = getStoredMemberClubCode()
  window.history.replaceState(window.history.state, '', savedClub ? `/${savedClub}/dashboard` : '/app')
}

function CapgoReadySignal() {
  React.useLayoutEffect(() => {
    document.getElementById('root')?.setAttribute('data-react-mounted', 'true')
  }, [])
  useEffect(() => {
    if (isCapacitorRuntime()) {
      void notifyMembersMobileBundleReady()
      void logMembersMobileBundleVersions()
      const clubCode = getStoredMemberClubCode()
      if (clubCode) void sendMembersTransportDiagnostic(clubCode)
    }
  }, [])

  return null
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <PrivanaI18nProvider>
      <BrowserRouter>
        <MemberPortalApp />
        <CapgoReadySignal />
      </BrowserRouter>
    </PrivanaI18nProvider>
  </React.StrictMode>
)
